module.exports = __webpack_public_path__ + "static/img/banner3-2.12ffe52.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/img/banner3-2.jpg
// module id = 9wHe
// module chunks = 1